interface LoadingSkeletonProps {
  count?: number;
  type?: "card" | "line";
}

export default function LoadingSkeleton({ count = 3, type = "card" }: LoadingSkeletonProps) {
  if (type === "line") {
    return (
      <div className="space-y-3">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="h-4 bg-gray-200 rounded animate-pulse" style={{ width: `${70 + Math.random() * 30}%` }} />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-2xl p-4 border border-gray-100">
          <div className="flex justify-between items-start mb-3">
            <div className="space-y-2 flex-1">
              <div className="h-5 bg-gray-200 rounded animate-pulse w-32" />
              <div className="h-4 bg-gray-100 rounded animate-pulse w-24" />
            </div>
            <div className="h-6 bg-gray-100 rounded-full animate-pulse w-20" />
          </div>
          <div className="flex gap-4">
            <div className="h-4 bg-gray-100 rounded animate-pulse w-24" />
            <div className="h-4 bg-gray-100 rounded animate-pulse w-16" />
            <div className="h-4 bg-gray-100 rounded animate-pulse w-20" />
          </div>
        </div>
      ))}
    </div>
  );
}
